// extracted by mini-css-extract-plugin
module.exports = {"box":"Boxes-module--box--J4wI7","horizontal":"Boxes-module--horizontal--2N0nN","canvas":"Boxes-module--canvas--2hhIB"};